import PersonRoundedIcon from '@mui/icons-material/PersonRounded';
import { LoginPage } from '@teuteuf-games/login-page';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';

import { BackButton } from '../components/buttons/BackButton';
import { useUser } from '../providers/UserProvider';

export const AccountRoute = () => {
  const { i18n, t } = useTranslation();
  const { userDetails, referer, logout } = useUser();
  const history = useHistory();
  const [photoError, setPhotoError] = useState(false);

  const isPremiumUser = userDetails.premiumGames?.includes('flagle');
  const showPhoto = userDetails.isPhotoValid && !photoError;

  const authUrl =
    window?.location.hostname === 'localhost'
      ? 'http://localhost:3000'
      : 'https://auth.teuteuf.fr';

  return (
    <div className="mx-auto w-full max-w-xl px-3 pb-8 text-slate-900 dark:text-white md:px-0">
      <div className="flex items-center justify-between pt-4">
        <BackButton />
      </div>
      <div className="mt-5">
        {!userDetails.loggedIn && (
          <div className="flex justify-center">
            <LoginPage
              languageCode={i18n.language}
              referer={referer}
              authServerUrl={authUrl}
            />
          </div>
        )}
        {userDetails.loggedIn && (
          <div className="space-y-4">
            <section className="relative overflow-hidden rounded-2xl border border-slate-200 bg-white p-5 shadow-sm dark:border-slate-700 dark:bg-slate-800">
              <div className="relative flex items-center gap-4">
                <div className="flex h-16 w-16 shrink-0 items-center justify-center overflow-hidden rounded-full bg-[#279536] text-2xl text-white shadow-sm">
                  {showPhoto ? (
                    <img
                      src={userDetails.photoURL}
                      alt=""
                      className="h-full w-full object-cover"
                      onError={() => setPhotoError(true)}
                    />
                  ) : (
                    <PersonRoundedIcon fontSize="inherit" />
                  )}
                </div>
                <div className="min-w-0">
                  <h1 className="truncate text-2xl font-bold tracking-tight">
                    {userDetails.firstName}
                  </h1>
                  {isPremiumUser && (
                    <p className="mt-1 flex items-center gap-1 text-sm font-semibold text-[#b07b00] dark:text-[#f4d477]">
                      <img
                        src="/images/icons/teuteuf_passport.png"
                        alt=""
                        className="h-5 w-5 object-contain"
                      />
                      {t('account.loggedIn.premiumLabel')}
                    </p>
                  )}
                </div>
              </div>
              <p className="relative mt-5 max-w-lg text-sm leading-6 text-slate-600 dark:text-slate-300">
                {t('account.loggedIn.text')}
              </p>
            </section>

            <section className="rounded-xl border border-slate-200 bg-slate-50 p-4 dark:border-slate-700 dark:bg-slate-900/40">
              <p className="block text-sm leading-5 text-slate-600 dark:text-slate-300">
                {t('archive.wantToPlayPrevious')}
              </p>
              <div className="mt-3 flex flex-col gap-2 sm:flex-row">
                <button
                  onClick={() => history.push('/archive')}
                  className="flex-1 rounded-lg border border-slate-300 bg-white px-4 py-2 text-sm font-bold text-slate-800 shadow-sm transition-colors hover:border-green-500 hover:text-green-700 dark:border-slate-600 dark:bg-slate-800 dark:text-white dark:hover:border-green-500 dark:hover:text-green-400"
                >
                  {t('member.playArchive')}
                </button>
                <button
                  onClick={() => history.push('/replay')}
                  className="flex-1 rounded-lg border border-slate-300 bg-white px-4 py-2 text-sm font-bold text-slate-800 shadow-sm transition-colors hover:border-green-500 hover:text-green-700 dark:border-slate-600 dark:bg-slate-800 dark:text-white dark:hover:border-green-500 dark:hover:text-green-400"
                >
                  {t('archive.replayTodaysGame')}
                </button>
              </div>
            </section>

            <div className="grid grid-cols-1 gap-2 pt-1 sm:grid-cols-2">
              <button
                onClick={logout}
                className="rounded-lg bg-slate-900 px-4 py-2.5 text-sm font-bold text-white transition-colors hover:bg-slate-700 dark:bg-white dark:text-slate-900 dark:hover:bg-slate-200"
              >
                {t('account.loggedIn.signOut')}
              </button>
              <a
                href="https://account.teuteuf.fr"
                className="rounded-lg border border-slate-300 px-4 py-2.5 text-center text-sm font-bold text-slate-700 transition-colors hover:border-green-500 hover:text-green-700 dark:border-slate-600 dark:text-slate-200 dark:hover:border-green-500 dark:hover:text-green-400"
              >
                {t('account.loggedIn.manageAccount')}
              </a>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default AccountRoute;
